var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuTurkey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_20397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15C11.6421 15 15 11.6421 15 7.5C15 3.35786 11.6421 0 7.5 0C3.35786 0 0 3.35786 0 7.5C0 11.6421 3.35786 15 7.5 15Z",
    fill: "#E53030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6616 7.85324L11.3652 6.94855L10.2819 7.25418L9.64723 6.25293L9.59707 7.44684L8.54004 7.74496L9.56754 8.15137L9.51785 9.32371L10.2271 8.41199L11.2794 8.82777L10.6616 7.85324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23088 10.0665C6.90667 10.0594 6.58705 9.98844 6.29026 9.85777C5.99346 9.7271 5.72532 9.53924 5.50115 9.30492C5.27697 9.0706 5.10115 8.79442 4.98373 8.49214C4.86631 8.18986 4.80959 7.86741 4.81682 7.54321C4.80273 6.88863 5.04908 6.25524 5.50174 5.7822C5.95439 5.30915 6.57632 5.03515 7.23088 5.02039C7.63573 4.99461 8.0392 5.08878 8.39079 5.29113C8.74239 5.49349 9.02651 5.79504 9.2076 6.15805C9.01682 5.62573 8.661 5.16826 8.19202 4.85231C7.72304 4.53637 7.16541 4.37848 6.60041 4.40164C5.79636 4.4196 5.03234 4.75604 4.47622 5.33702C3.92011 5.91801 3.61741 6.69602 3.63463 7.50008C3.61716 8.30417 3.91979 9.08227 4.47597 9.66324C5.03215 10.2442 5.79632 10.5805 6.60041 10.598C7.07396 10.6377 7.54857 10.5351 7.96345 10.3033C8.37832 10.0716 8.71458 9.72127 8.92916 9.29727C8.74443 9.5695 8.48808 9.7854 8.18839 9.92114C7.88871 10.0569 7.55734 10.1072 7.23088 10.0665Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_20397"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuTurkey);
export default __webpack_public_path__ + "static/media/menuTurkey.428a3c694c6a9b11cccb6f27d7efa939.svg";
export { ForwardRef as ReactComponent };